import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBiMaD42IworZ-E70g3QgJN6y1TTJGF0DM",
  authDomain: "journal-app-d988a.firebaseapp.com",
  projectId: "journal-app-d988a",
  storageBucket: "journal-app-d988a.firebasestorage.app",
  messagingSenderId: "795909822436",
  appId: "1:795909822436:web:e4bb1bc049b313f38f99f1",
  measurementId: "G-2GG4YVE64L"
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app); // Explicitly export auth
export const db = getFirestore(app); // Explicitly export db